// buildPersonalAgendaEventItems.js — multi-type calendar items for Ai personal agenda

import {
  buildCalendarEventItems,
  compareCalendarEventItems,
} from 'views/calendar/shared/calendarUtils';
import { resolveDisplaySchemaFields } from 'views/utils/displaySchemaFields';

const DATE_FIELD_TYPES = new Set(['annualdate', 'date', 'datetime', 'daterange', 'datetimerange']);

const pickPreferredCalendarField = (fields = []) => {
  const rows = Array.isArray(fields) ? fields : [];
  const patterns = [/^due/i, /^start/i, /date/i];

  for (const pattern of patterns) {
    const match = rows.find((field) => pattern.test(String(field?.name || field?.key || '')));
    if (match) return match;
  }

  return rows[0] || null;
};

export function buildPersonalAgendaEventItems(nodes = [], getType) {
  if (typeof getType !== 'function') return [];

  const items = [];

  (Array.isArray(nodes) ? nodes : []).forEach((node) => {
    const typeKey = String(node?.type || '').trim();
    if (!typeKey) return;

    const typeDef = getType(typeKey);
    if (!typeDef) return;

    const resolvedTypeKey = typeDef.key || typeKey;
    const dateFields = resolveDisplaySchemaFields(typeDef, { includeHidden: false })
      .filter((field) => {
        const fieldType = String(field?.type || '').toLowerCase();
        const fieldKey = field?.name || field?.key;
        return fieldKey && DATE_FIELD_TYPES.has(fieldType);
      });

    if (!dateFields.length) return;

    const preferredField = pickPreferredCalendarField(dateFields);
    const fieldsForNode = preferredField ? [preferredField] : dateFields.slice(0, 1);

    items.push(...buildCalendarEventItems({
      nodes: [node],
      dateFields: fieldsForNode,
      typeKey: resolvedTypeKey,
    }));
  });

  return items.sort(compareCalendarEventItems);
}
